<!-- @format -->

<template>
  <div class="col-6 mx-auto text-center">
    <h1>Sorry</h1>
    <p>Something went wrong.<br />Please try again.</p>
    <RouterLink class="btn btn-primary" :to="{ name: 'home' }"
      >Return home</RouterLink
    >
  </div>
</template>

<script setup lang="ts">
import { setDocumentHead } from "@/composables/useDocumentHead";

setDocumentHead({
  title: "Error",
  description:
    "Something went wrong loading this page. Return to Outstanding Photos to keep browsing fine-art photography prints, framed or unframed.",
});
</script>

<style></style>
